import {memo} from 'react'
import * as React from 'react'

import type {ProjectId} from '../../../../../types'
import InvestigationStatusFilter from '../../../../common/InvestigationStatusFilter/InvestigationStatusFilter'
import ProjectOverviewToolBar from '../../../../common/ProjectToolbar/ProjectToolBar'

import styles from './BuildProblemFilter.css'

type Props = {
  projectId: ProjectId
}

function BuildProblemFilter({projectId}: Props) {
  return (
    <div className={styles.row}>
      <InvestigationStatusFilter />
      <ProjectOverviewToolBar
        projectId={projectId}
        onlyFavorites={false}
        className={styles.expandCollapse}
      />
    </div>
  )
}

export default memo(BuildProblemFilter)
